export default "__VITE_ASSET__BOnMwk59__"